import { Theme } from '@mui/system'
import { makeStyles } from '@mui/styles'
import { FONTS, SPACES } from 'src/constants'

interface IProps {
  fullWidth?: boolean
}

export const useStyles = makeStyles((theme: Theme) => ({
  section: {
    '&&': {
      display: 'flex',
      flexDirection: 'column',
      flexWrap: 'wrap',
      padding: `${SPACES.xs} ${SPACES.xxl} ${SPACES.xxl}`,

      [theme.breakpoints.down('tablet')]: {
        width: '100%',
        height: 'auto',

        border: `1px solid ${theme.palette.custom.grey}`,
        borderRadius: 10,
      },

      [theme.breakpoints.up('tablet')]: {
        border: `1px solid ${theme.palette.custom.grey}`,
        borderRadius: 15,

        minWidth: 335,
      },
    },
  },
  label: {
    marginBottom: SPACES.xxxs,

    fontWeight: FONTS.WEIGHTS.medium,
    color: theme.palette.custom.grey2,

    [theme.breakpoints.down('tablet')]: {
      fontSize: FONTS.SIZES.s,
    },
    [theme.breakpoints.up('tablet')]: {
      fontSize: FONTS.SIZES.xs,
    },
  },
  fieldsContainer: {
    display: 'flex',
    flexDirection: 'column',

    width: 'inherit',

    [theme.breakpoints.down('tablet')]: {
      gap: SPACES.xs,
    },
    [theme.breakpoints.up('tablet')]: {
      gap: SPACES.xxl,
    },
  },
  fieldsYWrapper: {
    '&&': {
      display: 'flex',
      flexDirection: 'column',

      [theme.breakpoints.down('tablet')]: {
        gap: SPACES.xs,
      },
      [theme.breakpoints.up('tablet')]: {
        rowGap: SPACES.xxl,
        columnGap: SPACES.xxxxxl,
      },
    },
  },
  fieldsXWrapper: {
    '&&': {
      width: 'inherit',

      display: 'flex',
      flexWrap: 'wrap',

      [theme.breakpoints.down('tablet')]: {
        justifyContent: 'space-between',
        rowGap: SPACES.xxl,
        gap: SPACES.xs,
      },

      [theme.breakpoints.up('tablet')]: {
        rowGap: SPACES.xxl,
        columnGap: SPACES.xxxxxl,
      },
    },
  },

  fieldsWrapper: {
    '&&': {
      display: 'flex',

      [theme.breakpoints.down('tablet')]: {
        flexDirection: 'column',
        gap: SPACES.xs,
      },
      [theme.breakpoints.up('tablet')]: {
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        rowGap: SPACES.xxl,
      },
    },
  },
  field: ({ fullWidth }: IProps) => ({
    '&&': {
      display: 'flex',
      flexDirection: 'column',

      [theme.breakpoints.up('tablet')]: {
        padding: `${SPACES.xxxs} ${SPACES.xs} ${SPACES.xxxs}`,
        width: fullWidth ? '100%' : 370,
        height: 60,

        backgroundColor: theme.palette.custom.greyTransparent,
        border: `1px solid ${theme.palette.custom.grey}`,
        borderRadius: 15,
      },
    },
  }),
  fieldLabel: {
    margin: 0,
    marginBottom: SPACES.xxxs,

    fontWeight: FONTS.WEIGHTS.light,
    color: theme.palette.custom.grey2,
    fontSize: FONTS.SIZES.xs,
  },
  valueWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  value: {
    '&&': {
      margin: 0,
      width: '100%',

      color: theme.palette.custom.darkBlue2,
      fontWeight: FONTS.WEIGHTS.light,
      lineHeight: 1.4,

      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',

      [theme.breakpoints.down('laptop')]: {
        fontSize: FONTS.SIZES.s,
      },
      [theme.breakpoints.up('tablet')]: {
        textOverflow: 'ellipsis',
        fontSize: FONTS.SIZES.m,
      },
    },
  },
  iconButton: {
    '&&': {
      padding: 2,
    },
  },
  icon: {
    height: 16,
    width: 'auto',
  },
  actionsWrapper: {
    '&&': {
      display: 'flex',
      justifyContent: 'flex-start',
      columnGap: SPACES.xxl,
      flexWrap: 'wrap',

      [theme.breakpoints.down('tablet')]: {
        width: 'inherit',
        rowGap: SPACES.xs,
      },
      [theme.breakpoints.up('tablet')]: {
        rowGap: SPACES.xxl,
      },
    },
  },
  imageWrapper: {
    display: 'flex',
    gap: SPACES.xs,
    alignItems: 'center',

    [theme.breakpoints.down('tablet')]: {
      flexDirection: 'column',
    },
  },
}))
